const { SET_NTH_BRAND } = require('../../constants/actionTypes/nthBrand');

const initialState = {};

const reducer = function (state = initialState, action) {
    const {
        type, payload
    } = action;

    switch (type) {
        case SET_NTH_BRAND: {
            const {
                data, requestOptions, displayOptions
            } = payload;

            return {
                ...initialState,
                ...data,
                requestOptions,
                displayOptions
            };
        }
        default: {
            return state;
        }
    }
};

module.exports = reducer;
